import { useContext } from 'react';
import { PluginContext } from 'ts-components/Plugins/PluginContext';
import { MarketPlacePluginApiName } from 'pages/Marketplace/types';

export const useAIFeatures = () => {
  const { pluginAPINamesToIds = {} } = useContext(PluginContext);

  return {
    aiFeaturesEnabled: MarketPlacePluginApiName.KizenAI in pluginAPINamesToIds,
  };
};
